import React, { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../styles/FinishSignupPage.css";
import { useAuth } from "../auth/useAuth";
import { setIdentifier } from "../utils/auth"; // ✅ legacy support

const FinishSignupPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { refresh } = useAuth(); // ✅ critical

  const apiBase = useMemo(
    () => "https://squid-app-6s2hc.ondigitalocean.app",
    []
  );

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);

  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const [error, setError] = useState("");
  const [usernameError, setUsernameError] = useState("");

  const validateUsername = (value) => {
  const v = value.trim();

  if (v.length < 2) {
    return "please choose a username with at least 2 characters";
  }

  if (v.length > 20) {
    return "please keep your username to 20 characters or fewer";
  }

  if (/\s/.test(v)) {
    return "please remove spaces from your username";
  }

  if (!/^[a-zA-Z0-9._-]+$/.test(v)) {
    return "usernames can only contain letters, numbers, ., _ and -";
  }

  return "";
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setUsernameError("");

    const uErr = validateUsername(username);
    if (uErr) {
      setUsernameError(uErr);
      return;
    }

    if (!password || password.length < 6) {
      setError("password must be at least 6 characters");
      return;
    }

    if (!token) {
      setError("this link looks incomplete. please request a new one.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${apiBase}/complete-signup/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include", // ✅ cookie auth
        body: JSON.stringify({
  username: username.trim(),
  password,
  name: "",
  rememberMe,
}),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok || !data.success) {
        if (data.code === "USERNAME_EXISTS") {
          setUsernameError("that username is taken. try another.");
          return;
        }
        setError(data.message || "something went wrong. please try again.");
        return;
      }

      setDone(true);

      // ✅ keep legacy pages working (10 pages still read getIdentifier())
      if (data.email) {
        setIdentifier(data.email, {
  remember: rememberMe
});
      }

      // ✅ CRITICAL STEP: hydrate auth context from cookie
      await refresh();

      // ✅ tiny safety net: cookie propagation edge cases
      setTimeout(() => {
        refresh().catch(() => {});
      }, 150);

      // ✅ go straight to homepage
      navigate("/home-page", { replace: true });
    } catch {
      setError("couldn’t finish signup. please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="FinishSignupPage">
      <div className="FinishSignupCard">
        {!done ? (
          <>
            <h1 className="finish-title">ツ</h1>

            <form onSubmit={handleSubmit} className="finish-form">
              <label className="finish-label" htmlFor="username">
                username
              </label>
              <input
                id="username"
                className="finish-input"
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setUsernameError("");
                  setError("");
                }}
                placeholder="create a username"
                autoComplete="username"
              />

              {usernameError && <p className="finish-error">{usernameError}</p>}

              <label className="finish-label" htmlFor="password">
                password
              </label>

              <div className="password-row">
                <input
                  id="password"
                  className="finish-input"
                  type={showPw ? "text" : "password"}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setError("");
                  }}
                  placeholder="create a password [6+]"
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="pw-toggle"
                  onClick={() => setShowPw((s) => !s)}
                  aria-label={showPw ? "hide password" : "show password"}
                >
                  {showPw ? "hide" : "show"}
                </button>
              </div>


              {error && <p className="finish-error">{error}</p>}

              <button className="finish-button" type="submit" disabled={loading}>
                {loading ? "creating..." : "create account"}
              </button>
              <label className="remember-row">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />

              <span className="remember-label">
                stay signed in
              </span>
            </label>

              <p className="finish-note">
                by creating an account, you consent to t.c.p. storing your account data.
                {" "}
                 <br />
                 <br />
                read more about how your data is used{" "}
                <a
                  href="/#/about?section=data-usage"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="finish-link"
                >
                  here
                </a>
                .
              </p>
            </form>
          </>
        ) : (
          <p className="finish-success">account created. taking you in.</p>
        )}
      </div>
      
    </div>
  );
};

export default FinishSignupPage;
